import { useContext } from "react";

import { PasswordContext } from "../contexts/PasswordContext";
// import { AuthContext } from "../contexts/FirebaseAuthContext";
// import { AuthContext } from "../contexts/Auth0Context";
// import { AuthContext } from "../contexts/CognitoContext";

const usePassword = () => {
  const context = useContext(PasswordContext);

  if (!context) throw new Error("PasswordContext must be placed within PasswordProvider");

  return context;
};

export default usePassword;
